<template>
  <span>
    <base-text class="d-flex headers mb-n3 pb-1">
      <div class="col-3">CLIENT</div>
      <div class="col-8">EMAIL</div>
      <div class="col-1 text-center">OPENS</div>
    </base-text>
    <base-cell
      v-for="(client, index) in clients"
      :key="`client_${index}_${client.customer.pk}`"
      class="d-flex py-3 my-1"
    >
      <div
        class="col-3 clickable"
        @click="onCustomerClicked(client.customer)"
      >
        <base-text size="m">{{ client.customer.first_name }} {{ client.customer.last_name }}</base-text>
      </div>
      <div
        class="col-8 clickable"
        @click="onCustomerClicked(client.customer)"
      >
        <base-text size="md">{{ client.customer.email }}</base-text>
      </div>
      <div
        class="col-1 text-center clickable underline"
        @click="onViewDetail(client.customer)"
      >
        <base-text size="md">{{ client.events.length }}</base-text>
      </div>
    </base-cell>
  </span>
</template>
<script>
export default {

  name: 'TopClients',
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onViewDetail(customer) {
      this.$emit('view-details', customer);
    },
    onCustomerClicked(customer) {
      this.$emit('customer-clicked', customer.pk);
    },
  },
};
</script>
<style lang="scss" scoped>
.headers {
  color: #AAAAAA;
  font-size: 11px;
}
.clickable {
  cursor: pointer;
  &.underline:hover {
    text-decoration: underline;
  }
}
</style>
